import ActionTypes from "../constants/action_types";

export default function clearFormTemplates(organisationId, projectId) {
  return {
    type: ActionTypes.FORM_TEMPLATES_CLEAR.SUCCESS,
    organisation_id: organisationId,
    project_id: projectId,
  };
}
